const GooglePlay = (props: Omit<React.SVGProps<SVGSVGElement>, 'fill'>) => {
  return (
    <svg
      width={75}
      height={25}
      viewBox='0 0 75 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_267_17439)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M72.2222 24.3105H2.79025C1.25242 24.3105 0 22.9579 0 21.3105V3.31055C0 1.65718 1.25242 0.310547 2.79025 0.310547H72.2222C73.7587 0.310547 75.0125 1.65718 75.0125 3.31055V21.3105C75.0125 22.9579 73.7587 24.3105 72.2222 24.3105Z'
          fill='#181818'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M72.2222 0.790846C73.512 0.790846 74.5677 1.92351 74.5677 3.31055V21.3105C74.5677 22.6976 73.519 23.8302 72.2222 23.8302H2.79025C1.50042 23.8302 0.444721 22.6976 0.444721 21.3105V3.31055C0.444721 1.92351 1.49349 0.790846 2.79025 0.790846H72.2222ZM72.2222 0.310547H2.79025C1.25242 0.310547 0 1.66317 0 3.31055V21.3105C0 22.9639 1.25242 24.3105 2.79025 24.3105H72.2222C73.7587 24.3105 75.0125 22.9639 75.0125 21.3105V3.31055C75.0125 1.66317 73.7587 0.310547 72.2222 0.310547Z'
          fill='#C2C2C2'
        />
        <path
          d='M37.853 14.3932C36.5463 14.3932 35.4813 15.3865 35.4813 16.756C35.4813 18.1165 36.5463 19.1187 37.853 19.1187C39.1597 19.1187 40.2247 18.1165 40.2247 16.756C40.2247 15.3865 39.1597 14.3932 37.853 14.3932ZM37.853 18.1882C37.1369 18.1882 36.5191 17.5976 36.5191 16.756C36.5191 15.9054 37.1369 15.3237 37.853 15.3237C38.5691 15.3237 39.1863 15.9054 39.1863 16.756C39.1863 17.5971 38.5691 18.1882 37.853 18.1882ZM32.6786 14.3932C31.3719 14.3932 30.3069 15.3865 30.3069 16.756C30.3069 18.1165 31.3719 19.1187 32.6786 19.1187C33.9852 19.1187 35.0502 18.1165 35.0502 16.756C35.0508 15.3865 33.9852 14.3932 32.6786 14.3932ZM32.6786 18.1882C31.9624 18.1882 31.3452 17.5976 31.3452 16.756C31.3452 15.9054 31.963 15.3237 32.6786 15.3237C33.3947 15.3237 34.0119 15.9054 34.0119 16.756C34.0124 17.5971 33.3947 18.1882 32.6786 18.1882ZM26.5241 15.1182V16.1204H28.923C28.8513 16.6843 28.6636 17.096 28.3769 17.3826C28.028 17.7315 27.4819 18.1165 26.5241 18.1165C25.0474 18.1165 23.893 16.926 23.893 15.4493C23.893 13.9726 25.0474 12.7821 26.5241 12.7821C27.3208 12.7821 27.9024 13.0954 28.3319 13.4982L29.0391 12.791C28.4397 12.2182 27.643 11.7793 26.5241 11.7793C24.5013 11.7793 22.8008 13.426 22.8008 15.4487C22.8008 17.4715 24.5013 19.1182 26.5241 19.1182C27.6158 19.1182 28.4397 18.7604 29.0841 18.0887C29.7463 17.4265 29.9524 16.4954 29.9524 15.7437C29.9524 15.511 29.9347 15.296 29.8986 15.1171H26.5241V15.1182ZM51.6952 15.8965C51.4986 15.3682 50.8986 14.3926 49.6725 14.3926C48.4552 14.3926 47.4441 15.3504 47.4441 16.7554C47.4441 18.0799 48.4463 19.1182 49.7891 19.1182C50.8719 19.1182 51.4986 18.456 51.758 18.071L50.9524 17.5337C50.6841 17.9276 50.3169 18.1871 49.7891 18.1871C49.2608 18.1871 48.8852 17.9454 48.6436 17.471L51.803 16.1643L51.6952 15.8965ZM48.473 16.6843C48.4463 15.7715 49.1802 15.306 49.708 15.306C50.1197 15.306 50.4686 15.5115 50.5852 15.8071L48.473 16.6843ZM45.9041 18.9754H46.9424V12.0304H45.9041V18.9754ZM44.2036 14.921H44.168C43.9352 14.6437 43.488 14.3926 42.9241 14.3926C41.7424 14.3926 40.6597 15.431 40.6597 16.7643C40.6597 18.0887 41.7424 19.1182 42.9241 19.1182C43.488 19.1182 43.9352 18.8676 44.168 18.581H44.2036V18.921C44.2036 19.8249 43.7202 20.3082 42.9413 20.3082C42.3058 20.3082 41.9119 19.8515 41.7508 19.4671L40.8469 19.8432C41.1063 20.4699 41.7958 21.2393 42.9413 21.2393C44.1586 21.2393 45.188 20.5232 45.188 18.7782V14.536H44.2036V14.921ZM43.0136 18.1882C42.2975 18.1882 41.698 17.5887 41.698 16.7649C41.698 15.9326 42.2975 15.3237 43.0136 15.3237C43.7208 15.3237 44.2752 15.9321 44.2752 16.7649C44.2752 17.5882 43.7208 18.1882 43.0136 18.1882ZM56.5586 12.0304H54.0747V18.9754H55.1108V16.3443H56.558C57.7069 16.3443 58.8363 15.5126 58.8363 14.1876C58.8363 12.8626 57.7075 12.0304 56.5586 12.0304ZM56.5852 15.3776H55.1108V12.9971H56.5852C57.3602 12.9971 57.8002 13.6387 57.8002 14.1876C57.8002 14.7254 57.3602 15.3776 56.5852 15.3776ZM62.9919 14.3804C62.2413 14.3804 61.4641 14.711 61.1424 15.4437L62.063 15.8282C62.2597 15.4437 62.6258 15.3187 63.0102 15.3187C63.5463 15.3187 64.0913 15.6404 64.1002 16.2121V16.2837C63.9124 16.1765 63.5102 16.0154 63.0191 16.0154C62.0274 16.0154 61.0174 16.5604 61.0174 17.5793C61.0174 18.5087 61.8308 19.1071 62.7419 19.1071C63.4391 19.1071 63.823 18.7943 64.0641 18.4282H64.0997V18.9643H65.1002V16.3015C65.1002 15.0682 64.1802 14.3804 62.9919 14.3804ZM62.8663 18.1865C62.5269 18.1865 62.053 18.0165 62.053 17.5971C62.053 17.061 62.643 16.8554 63.1519 16.8554C63.6075 16.8554 63.8219 16.9537 64.0991 17.0876C64.0191 17.731 63.4652 18.1865 62.8663 18.1865ZM68.7458 14.5321L67.5574 17.5432H67.5219L66.2891 14.5321H65.1724L67.0219 18.7404L65.9674 21.0815H67.0486L69.8991 14.5321H68.7458ZM59.4086 18.9754H60.4452V12.0304H59.4086V18.9754Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M40.8932 7.64373C40.5654 8.00793 40.1582 8.18913 39.671 8.18913C39.1838 8.18913 38.7765 8.00733 38.4493 7.64373C38.1215 7.28013 37.9582 6.83493 37.9582 6.30873C37.9582 5.78253 38.1215 5.33733 38.4493 4.97373C38.7765 4.60953 39.1838 4.42773 39.671 4.42773C40.1554 4.42773 40.5621 4.61073 40.891 4.97613C41.2199 5.34153 41.3843 5.78553 41.3843 6.30873C41.3843 6.83553 41.2204 7.28073 40.8932 7.64373ZM38.7654 7.34253C39.0121 7.61253 39.3138 7.74693 39.671 7.74693C40.0282 7.74693 40.3299 7.61193 40.5765 7.34253C40.8232 7.07253 40.9471 6.72813 40.9471 6.30933C40.9471 5.89053 40.8232 5.54553 40.5765 5.27613C40.3304 5.00613 40.0282 4.87173 39.671 4.87173C39.3138 4.87173 39.0121 5.00673 38.7654 5.27613C38.5193 5.54613 38.3954 5.89053 38.3954 6.30933C38.3954 6.72813 38.5193 7.07253 38.7654 7.34253Z'
          fill='white'
        />
        <path
          d='M26.3427 6.45513C26.3427 6.95793 26.2049 7.35813 25.9288 7.65693C25.6154 8.01213 25.2065 8.18973 24.7043 8.18973C24.2232 8.18973 23.8138 8.00973 23.4777 7.64973C23.141 7.28913 22.9727 6.84273 22.9727 6.30993C22.9727 5.77653 23.141 5.33013 23.4777 4.97013C23.8138 4.60953 24.2232 4.42953 24.7043 4.42953C24.9432 4.42953 25.1715 4.47993 25.3882 4.58013C25.6054 4.68093 25.7793 4.81473 25.9093 4.98213L25.6165 5.29893C25.396 5.01393 25.0921 4.87173 24.7038 4.87173C24.3527 4.87173 24.0493 5.00493 23.7932 5.27133C23.5377 5.53773 23.4099 5.88333 23.4099 6.30933C23.4099 6.73533 23.5377 7.08093 23.7938 7.34793C24.0499 7.61433 24.3532 7.74753 24.7043 7.74753C25.0765 7.74753 25.3871 7.61373 25.6354 7.34553C25.7965 7.17093 25.8899 6.92793 25.9149 6.61653H24.7043V6.18333H26.3193C26.3354 6.27753 26.3427 6.36813 26.3427 6.45513Z'
          fill='white'
        />
        <path
          d='M28.9038 4.95154H27.386V6.09274H28.7549V6.52534H27.386V7.66654H28.9038V8.10934H26.9577V4.50934H28.9038V4.95154Z'
          fill='white'
        />
        <path
          d='M30.281 8.10934H30.7093V4.95154H31.6404V4.50934H29.3499V4.95154H30.281V8.10934Z'
          fill='white'
        />
        <path
          d='M33.2982 8.10934V4.50934H33.7265V8.10934H33.2982Z'
          fill='white'
        />
        <path
          d='M35.1971 8.10934H35.6254V4.95154H36.5565V4.50934H34.266V4.95154H35.1971V8.10934Z'
          fill='white'
        />
        <path
          d='M41.9854 4.50934V8.10934H42.4127V5.86654L42.3943 5.17294H42.4127L44.1077 8.10934H44.5549V4.50934H44.1265V6.61654L44.1449 7.31014H44.1265L42.5065 4.50934H41.9854Z'
          fill='white'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M40.8932 7.64373C40.5654 8.00793 40.1582 8.18913 39.671 8.18913C39.1838 8.18913 38.7765 8.00733 38.4493 7.64373C38.1215 7.28013 37.9582 6.83493 37.9582 6.30873C37.9582 5.78253 38.1215 5.33733 38.4493 4.97373C38.7765 4.60953 39.1838 4.42773 39.671 4.42773C40.1554 4.42773 40.5621 4.61073 40.891 4.97613C41.2199 5.34153 41.3843 5.78553 41.3843 6.30873C41.3843 6.83553 41.2204 7.28073 40.8932 7.64373ZM38.7654 7.34253C39.0121 7.61253 39.3138 7.74693 39.671 7.74693C40.0282 7.74693 40.3299 7.61193 40.5765 7.34253C40.8232 7.07253 40.9471 6.72813 40.9471 6.30933C40.9471 5.89053 40.8232 5.54553 40.5765 5.27613C40.3304 5.00613 40.0282 4.87173 39.671 4.87173C39.3138 4.87173 39.0121 5.00673 38.7654 5.27613C38.5193 5.54613 38.3954 5.89053 38.3954 6.30933C38.3954 6.72813 38.5193 7.07253 38.7654 7.34253Z'
          stroke='white'
          strokeWidth={0.111111}
          strokeMiterlimit={10}
        />
        <path
          d='M26.3427 6.45513C26.3427 6.95793 26.2049 7.35813 25.9288 7.65693C25.6154 8.01213 25.2065 8.18973 24.7043 8.18973C24.2232 8.18973 23.8138 8.00973 23.4777 7.64973C23.141 7.28913 22.9727 6.84273 22.9727 6.30993C22.9727 5.77653 23.141 5.33013 23.4777 4.97013C23.8138 4.60953 24.2232 4.42953 24.7043 4.42953C24.9432 4.42953 25.1715 4.47993 25.3882 4.58013C25.6054 4.68093 25.7793 4.81473 25.9093 4.98213L25.6165 5.29893C25.396 5.01393 25.0921 4.87173 24.7038 4.87173C24.3527 4.87173 24.0493 5.00493 23.7932 5.27133C23.5377 5.53773 23.4099 5.88333 23.4099 6.30933C23.4099 6.73533 23.5377 7.08093 23.7938 7.34793C24.0499 7.61433 24.3532 7.74753 24.7043 7.74753C25.0765 7.74753 25.3871 7.61373 25.6354 7.34553C25.7965 7.17093 25.8899 6.92793 25.9149 6.61653H24.7043V6.18333H26.3193C26.3354 6.27753 26.3427 6.36813 26.3427 6.45513Z'
          stroke='white'
          strokeWidth={0.111111}
          strokeMiterlimit={10}
        />
        <path
          d='M28.9038 4.95154H27.386V6.09274H28.7549V6.52534H27.386V7.66654H28.9038V8.10934H26.9577V4.50934H28.9038V4.95154Z'
          stroke='white'
          strokeWidth={0.111111}
          strokeMiterlimit={10}
        />
        <path
          d='M30.281 8.10934H30.7093V4.95154H31.6404V4.50934H29.3499V4.95154H30.281V8.10934Z'
          stroke='white'
          strokeWidth={0.111111}
          strokeMiterlimit={10}
        />
        <path
          d='M33.2982 8.10934V4.50934H33.7265V8.10934H33.2982Z'
          stroke='white'
          strokeWidth={0.111111}
          strokeMiterlimit={10}
        />
        <path
          d='M35.1971 8.10934H35.6254V4.95154H36.5565V4.50934H34.266V4.95154H35.1971V8.10934Z'
          stroke='white'
          strokeWidth={0.111111}
          strokeMiterlimit={10}
        />
        <path
          d='M41.9854 4.50934V8.10934H42.4127V5.86654L42.3943 5.17294H42.4127L44.1077 8.10934H44.5549V4.50934H44.1265V6.61654L44.1449 7.31014H44.1265L42.5065 4.50934H41.9854Z'
          stroke='white'
          strokeWidth={0.111111}
          strokeMiterlimit={10}
        />
        <path
          d='M6.26066 5.52704C6.09683 5.69468 6 5.95484 6 6.29175V18.3291C6 18.6665 6.09683 18.9262 6.26066 19.0938L6.30232 19.133L13.277 12.3899V12.3104V12.231L6.30232 5.4873L6.26066 5.52704Z'
          fill='url(#paint0_linear_267_17439)'
        />
        <path
          d='M15.6021 14.6391L13.2776 12.3907V12.3112V12.2318L15.6027 9.98389L15.655 10.0127L18.4097 11.5258C19.1967 11.958 19.1967 12.665 18.4097 13.0977L15.655 14.6108L15.6021 14.6391Z'
          fill='url(#paint1_linear_267_17439)'
        />
        <path
          d='M15.6552 14.6096L13.2777 12.3105L6.26074 19.0939C6.52027 19.3595 6.94814 19.3922 7.43061 19.1271L15.6552 14.6096Z'
          fill='url(#paint2_linear_267_17439)'
        />
        <path
          d='M15.6551 10.0116L7.4311 5.49401C6.94863 5.22895 6.52076 5.26215 6.26123 5.52721L13.2776 12.3106L15.6551 10.0116Z'
          fill='url(#paint3_linear_267_17439)'
        />
        <path
          opacity={0.2}
          d='M15.6028 14.5591L7.43117 19.0478C6.97403 19.2987 6.56531 19.2824 6.30297 19.0538L6.26074 19.0946L6.3024 19.1338C6.56475 19.3624 6.97347 19.3792 7.43061 19.1278L15.6546 14.6102L15.6028 14.5591Z'
          fill='#181818'
        />
        <path
          opacity={0.12}
          d='M6.26066 19.0142C6.09683 18.8466 6 18.5864 6 18.2495V18.329C6 18.6659 6.09683 18.9261 6.26066 19.0937L6.30288 19.0529L6.26066 19.0142Z'
          fill='#181818'
        />
        <path
          opacity={0.12}
          d='M18.4098 13.017L15.6028 14.5589L15.6551 14.6095L18.4098 13.0964C18.8033 12.8804 18.9998 12.5957 18.9998 12.311C18.9666 12.5685 18.7662 12.821 18.4098 13.017Z'
          fill='#181818'
        />
        <path
          opacity={0.25}
          d='M7.43053 5.57326L18.4092 11.6039C18.7661 11.7998 18.9659 12.0524 18.9992 12.3104C18.9992 12.0257 18.8027 11.7405 18.4092 11.5244L7.43053 5.49379C6.64348 5.06163 6 5.42031 6 6.29171V6.37172C6 5.50032 6.64405 5.1411 7.43053 5.57326Z'
          fill='white'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_267_17439'
          x1={12.6587}
          y1={6.16483}
          x2={3.52952}
          y2={15.6076}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00A0FF' />
          <stop offset={0.0066} stopColor='#00A1FF' />
          <stop offset={0.2601} stopColor='#00BEFF' />
          <stop offset={0.5122} stopColor='#00D2FF' />
          <stop offset={0.7604} stopColor='#00DFFF' />
          <stop offset={1} stopColor='#00E3FF' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_267_17439'
          x1={19.4339}
          y1={12.311}
          x2={5.8116}
          y2={12.311}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFE000' />
          <stop offset={0.4087} stopColor='#FFBD00' />
          <stop offset={0.7754} stopColor='#FFA500' />
          <stop offset={1} stopColor='#FF9C00' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_267_17439'
          x1={14.3631}
          y1={13.5598}
          x2={1.98319}
          y2={26.3649}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF3A44' />
          <stop offset={1} stopColor='#C31162' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_267_17439'
          x1={4.49416}
          y1={1.52037}
          x2={10.0223}
          y2={7.23837}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#32A071' />
          <stop offset={0.0685} stopColor='#2DA771' />
          <stop offset={0.4762} stopColor='#15CF74' />
          <stop offset={0.8009} stopColor='#06E775' />
          <stop offset={1} stopColor='#00F076' />
        </linearGradient>
        <clipPath id='clip0_267_17439'>
          <rect
            width={75}
            height={24}
            fill='white'
            transform='translate(0 0.310547)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GooglePlay;
